import { NEWBUILDINGS_GENPLAN_IN_CARD } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const isGenplanExperimentEnable = (state: IApplicationState): boolean => {
  const { experiments } = state;

  const groupB = isAbUseExperimentActive(experiments, NEWBUILDINGS_GENPLAN_IN_CARD, 'enabled');
  const groupC = isAbUseExperimentActive(experiments, NEWBUILDINGS_GENPLAN_IN_CARD, 'with_offers_enabled');

  return groupB || groupC;
};

export const isLayoutExperimentEnable = (state: IApplicationState): boolean => {
  const { experiments } = state;
  const groupB = isAbUseExperimentActive(experiments, NEWBUILDINGS_GENPLAN_IN_CARD, 'enabled');
  const groupC = isAbUseExperimentActive(experiments, NEWBUILDINGS_GENPLAN_IN_CARD, 'with_offers_enabled');

  return groupB || groupC;
};

export const isOffersExperimentEnable = (state: IApplicationState): boolean => {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, NEWBUILDINGS_GENPLAN_IN_CARD, 'enabled');
};
